{
  "sidebar": {
    "description": "Täällä voit varata itsellesi käyttöoikeuden. Käyttöoikeus kattaa yhden henkilön.",
    "ownAccessNone": "Omat kuntosalikäyttöoikeudet: Sinulla ei ole toistaiseksi voimassa olevaa kuntosalikäyttöoikeutta.",
    "ownAccessWithCount_one": "Omat kuntosalikäyttöoikeudet: Sinulla on yksi voimassa oleva kuntosalikäyttöoikeus.",
    "ownAccessWithCount_other": "Omat kuntosalikäyttöoikeudet: Sinulla on {{count}} voimassa olevaa kuntosalikäyttöoikeutta.",
    "ownAccessLoading": "Omat kuntosalikäyttöoikeudet: ladataan..."
  },
  "modal": {
    "title": "Varaa",
    "releaseTitle": "Luovu",
    "headerReserve": "Kuntosalin käyttöoikeus",
    "headerRelease": "Kuntosalin käyttöoikeus",
    "gymRulesLink": "Säännöt",
    "gymAccessTermsLink": "Varausehdot",
    "acceptRules": "Hyväksyn säännöt ja käyttöoikeudenvarausehdot",
    "cancel": "Peruuta",
    "confirm": "Vahvista",
    "priceLabel": "Hinta",
    "perMonth": "€ / kk"
  },
  "reservation": {
    "title": "Kuntosali",
    "availabilitySentence": "Kuntosalilla on tällä hetkellä vapaana",
    "availabilitySentenceBold": "{{count}} käyttöoikeutta.",
    "today": "Tänään",
    "priceLabel": "Hinta",
    "priceAtStart": "Hinta sopimuksen alkaessa {{price}} € / kk.",
    "buttonReserve": "Varaa",
    "buttonRelease": "Luovu käyttöoikeudesta",
    "releaseAccessEnding": "Käyttöoikeus on jo irtisanottu eikä sitä voi enää muuttaa.",
    "releaseAccessFuture": "Tulevan varauksen voi perua asiakaspalvelun kautta.",
    "releaseAccessUnavailable": "Vain sopimuksen osapuoli tai maksaja voi luopua käyttöoikeudesta.",
    "currentAccessTitle": "Nykyiset varaukset",
    "validUntil": "Voimassa {{startDate}} - {{endDate}}.",
    "validFrom": "Voimassa toistaiseksi {{startDate}} alkaen.",
    "endsOnLabel": "Päättyy {{endDate}}",
    "activeLabel": "Voimassa",
    "reachedLimitInfo": "Olet saavuttanut voimassa olevien varausten enimmäismäärän ({{max}}), etkä voi tehdä niitä enempää.",
    "accessSummary": {
      "none": "Sinulla ei ole voimassa olevaa kuntosalikäyttöoikeutta.",
      "active_one": "Sinulla on yksi voimassa oleva kuntosalikäyttöoikeus.",
      "active_other": "Sinulla on {{count}} voimassa olevaa kuntosalikäyttöoikeutta.",
      "terminating": "Olet irtisanonut käyttöoikeutesi salille. Käyttöoikeutesi on voimassa {{endDate}} asti."
    }
  },
  "reservationModal": {
    "reservationStartsLabel": "Varaus astuu voimaan",
    "successTitle": "Käyttöoikeus varattu!",
    "successMessage": "Kuntosalin käyttöoikeus on nyt varattu!",
    "accessStartsLabel": "Käyttöoikeus alkaa:",
    "priceLabel": "Hinta:",
    "perMonth": "€ / kk",
    "acceptRulesPrefix": "Hyväksyn",
    "acceptRulesSuffix": "säännöt ja kuntosalin käyttöoikeudenvarausehdot",
    "contractNotStartedError": "Varaus ei voi alkaa ennen sopimuksen alkamispäivää."
  },
  "releaseModal": {
    "successTitle": "Käyttöoikeus poistettu!",
    "successMessage": "Kuntosalin käyttöoikeus on nyt poistettu!",
    "confirmQuestion": "Haluatko varmasti luopua käyttöoikeudesta?",
    "accessDetails": "Käyttöoikeus: {{address}}, voimassa alkaen {{startDate}}.",
    "validUntilImmediate": "Jos irtisanot nyt käyttöoikeutesi, se päättyy heti.",
    "validUntilPrefix": "Jos irtisanot nyt käyttöoikeutesi, se on voimassa",
    "validUntilSuffix": "asti."
  },
  "noCalendarsAvailable": "Ei varauskalentereita saatavilla",
  "timeFormatting": {
    "startingFrom": "alkaen",
    "priceAddedToContract": "lisätään sopimuksellesi"
  }
}
